import { ProductPanelScrollMarker } from '@Components/ProductDetailPanel/product-panel-scroll-marker';
import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import useCheckoutPresenter from '@Screens/Checkout/presenter';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';

import OwnableTheme from '../../../../assets/OwnableTheme';
import OrderSummary from '../OrderSummary';
import SummaryStep from '../SummaryStep';
import GuestOrLoginStep from './GuestOrLoginStep';
import LoginDetailsStep from './LoginDetailsStep';
import OrderDetailsStep from './OrderDetailsStep';
// import NativeOrderDetailsStep from "./OrderDetailsStep.native";
import OrderDetailsWrapper from './OrderDetailsWrapper';

import { useCheckoutStore } from '~stores/checkout';

const StyledContainer = styled.View`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  padding: 20px 12px;
  border-radius: 20px;
`;

const StyledRoot = styled.View`
  padding: ${IS_SMALL_SCREEN ? 0 : 20}px;
  margin-bottom: 30px;
`;

export const defaultInputProps = {
  fontSizePx: 16,
  gutterBottom: 30,
  borderBottomColor: OwnableTheme.colors.grayInput,
  placeholderColor: OwnableTheme.colors.gray,
  textColor: OwnableTheme.colors.black,
};

const Checkout: FC = () => {
  const { setCheckoutOrderId, orderDetailsVisible } = useCheckoutPresenter();
  const { isFeatureAvailableForCheckout } = useCheckoutStore();

  useEffect(() => {
    setCheckoutOrderId();
    // return () => handleCancelCheckoutFlow();
  }, []);

  const getDetailsStep = () => {
    if (!orderDetailsVisible.value) {
      return null;
    }

    return Platform.OS !== 'web' ? (
      <OrderDetailsStep />
    ) : (
      <OrderDetailsWrapper />
    );
  };

  return (
    <StyledRoot>
      <StyledContainer>
        <ProductPanelScrollMarker autoFocus />
        {isFeatureAvailableForCheckout('ShowOrderInfo') && <OrderSummary />}

        <GuestOrLoginStep />
        <LoginDetailsStep />
        {getDetailsStep()}
        <SummaryStep />
      </StyledContainer>
    </StyledRoot>
  );
};

export default observer(Checkout);
